import React from 'react';
import AccessibilityStatement from '../../accessibility/AccessibilityStatement';
import { APP_VERSION } from '../../../config/version';

/**
 * תוכן פוטר-הטלפון: קישור "הצהרת נגישות" + זכויות + מספר-גרסה.
 *
 * ★ מקור-אמת אחד לשני המקומות שבהם הוא מופיע, כדי שהנוסח/הגרסה לא יתפצלו:
 *   1. מסך-הלוגין  — `className="ans-mobile-footer"`, מקובע מעל כפתור ה-CTA (Login.css).
 *   2. "התורים שלי" — `className="appt-footer"`, בזרימה בתחתית העמוד (Appointments.css).
 *   העיצוב כולו נשען על ה-className שמועבר מבחוץ; הרכיב עצמו לא מחליט מיקום.
 *
 * ⚠️ ‏`ans-mobile-footer` הוא שם-הקלאס שה-CSS הקיים של הלוגין תלוי בו — לא לשנות.
 */
const AppFooterMobile = ({ className = '' }) => (
  <div className={('ans-mfoot ' + className).trim()}>
    <AccessibilityStatement className="ans-a11y-trigger ans-a11y-trigger--mobile" />
    <div className="ans-copyright ans-copyright--mobile">
      Copyright © ANS Tech ltd.<br />
      All rights reserved.<br />
      v{APP_VERSION}
    </div>
  </div>
);

export default AppFooterMobile;
